// src/components/brandCustomization/shared/TextInput.jsx
import React from 'react';

/**
 * TextInput - Input de texto reutilizable
 */
const TextInput = ({
    label,
    value,
    onChange,
    placeholder = '',
    hint = null,
    maxLength = null,
    className = ''
}) => {
    return (
        <div className={className}>
            {label && (
                <label className="block text-sm font-medium text-gray-700 mb-2">
                    {label}
                    {hint && <span className="text-gray-400 ml-2 font-normal">{hint}</span>}
                </label>
            )}
            <input
                type="text"
                value={value}
                onChange={(e) => onChange(e.target.value)}
                placeholder={placeholder}
                maxLength={maxLength}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
        </div>
    );
};

export default TextInput;

